import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Container,
  Typography,
  Grid,
  CardContent,
  CardMedia,
  CardActionArea,
  Box,
  Chip
} from '@mui/material';
import { AccessTime, Person } from '@mui/icons-material';
import PublicHeader from '../PublicHeader/PublicHeader';
import { BlogCard, BlogMeta } from './Blog.styles';

function Blog() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const blogPosts = [
    {
      id: 'standing-desk-benefits',
      title: t('blogPost1Title'),
      excerpt: t('blogPost1Excerpt'),
      category: t('categoryHealth'),
      readTime: '5 min',
      author: 'StandStrong Team',
      image: '/blog-images/standing-desk.jpg',
      date: '2025-10-01'
    },
    {
      id: 'optimal-desk-height',
      title: t('blogPost2Title'),
      excerpt: t('blogPost2Excerpt'),
      category: t('categoryErgonomics'),
      readTime: '7 min',
      author: 'StandStrong Team',
      image: '/blog-images/ergonomics.jpg',
      date: '2025-09-28'
    },
    {
      id: 'standing-sitting-rhythm',
      title: t('blogPost3Title'),
      excerpt: t('blogPost3Excerpt'),
      category: t('categoryProductivity'),
      readTime: '6 min',
      author: 'StandStrong Team',
      image: '/blog-images/rhythm.jpg',
      date: '2025-09-25'
    },
    {
      id: 'team-motivation',
      title: t('blogPost4Title'),
      excerpt: t('blogPost4Excerpt'),
      category: t('categoryTeams'),
      readTime: '5 min',
      author: 'StandStrong Team',
      image: '/blog-images/team.jpg',
      date: '2025-09-20'
    },
    {
      id: 'homeoffice-ergonomics',
      title: t('blogPost5Title'),
      excerpt: t('blogPost5Excerpt'),
      category: t('categoryErgonomics'),
      readTime: '8 min',
      author: 'StandStrong Team',
      image: '/blog-images/homeoffice.jpg',
      date: '2025-09-15'
    },
    {
      id: 'back-pain-prevention',
      title: t('blogPost6Title'),
      excerpt: t('blogPost6Excerpt'),
      category: t('categoryHealth'),
      readTime: '6 min',
      author: 'StandStrong Team',
      image: '/blog-images/health.jpg',
      date: '2025-09-10'
    }
  ];

  const handlePostClick = (postId) => {
    navigate(`/blog/${postId}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', overflowX: 'hidden' }}>
      <PublicHeader />

      {/* Hero Section */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 8,
          mb: 6
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h2"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
              lineHeight: 1.2,
              wordBreak: 'break-word'
            }}
          >
            {t('blogTitle')}
          </Typography>
          <Typography
            variant="h6"
            align="center"
            sx={{ opacity: 0.9, fontSize: { xs: '1rem', md: '1.25rem' } }}
          >
            {t('blogSubtitle')}
          </Typography>
        </Container>
      </Box>

      {/* Blog Posts Grid */}
      <Container maxWidth="lg" sx={{ flexGrow: 1, pb: 8 }}>
        <Grid container spacing={4}>
          {blogPosts.map((post) => (
            <Grid item xs={12} sm={6} md={4} key={post.id}>
              <BlogCard>
                <CardActionArea onClick={() => handlePostClick(post.id)}>
                  <CardMedia
                    component="div"
                    sx={{
                      height: 200,
                      bgcolor: 'primary.light',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <Typography variant="h6" color="white">
                      {post.category}
                    </Typography>
                  </CardMedia>
                  <CardContent>
                    <Chip
                      label={post.category}
                      size="small"
                      color="primary"
                      sx={{ mb: 1 }}
                    />
                    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                      {post.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" paragraph>
                      {post.excerpt}
                    </Typography>
                    <BlogMeta>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <AccessTime fontSize="small" />
                        <Typography variant="caption">{post.readTime}</Typography>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Person fontSize="small" />
                        <Typography variant="caption">{post.author}</Typography>
                      </Box>
                    </BlogMeta>
                  </CardContent>
                </CardActionArea>
              </BlogCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Blog;
